import { useEffect } from "react";
import { createContext, useContext, useState } from "react";

const ProjectInfoContext = createContext();

export const ProjectInfoProvider = ({ children }) => {
  const [projectData, setProjectData] = useState(() => {
    const saved = localStorage.getItem("projectInfo");
    return saved
      ? JSON.parse(saved)
      : {
          workingPressure: 100,
          soilDensity: 120,
          modulusOfSoilRtn: 1000,
          resin: "",
          sippInstaller: "",
        };
  });

  useEffect(() => {
    localStorage.setItem("projectInfo", JSON.stringify(projectData));
  }, [projectData]);


  // const [projectData, setProjectData] = useState({
  //   workingPressure: 100,
  //   soilDensity: 120,
  //   modulusOfSoilRtn: 1000,
  //   resin: "",
  // });

  // const [projectData, setProjectData] = useState(() => {
  //   const savedProject = JSON.parse(localStorage.getItem("projectInfo"));
  //   const savedUnit = localStorage.getItem("savedUnitSystem");

  //   if (savedProject) return savedProject;

  //   if (savedUnit === "si") {
  //     return {
  //       workingPressure: 0.69,
  //       soilDensity: 18.85,
  //       modulusOfSoilRtn: 6.89,
  //       resin: "",
  //     };
  //   }

  //   return {
  //     workingPressure: 100,
  //     soilDensity: 120,
  //     modulusOfSoilRtn: 1000,
  //     resin: "",
  //   };
  // });

  return (
    <ProjectInfoContext.Provider value={{ projectData, setProjectData }}>
      {children}
    </ProjectInfoContext.Provider>
  );
};

export const useProjectInfo = () => useContext(ProjectInfoContext);
